import { useEffect, useRef, useState } from "react";
import { ChevronDown } from "./Icons";
import { useEntities } from "../entity";

/** Entidade em uso no cabeçalho (PJ): lista só as empresas ativas que o usuário pode acessar. */
export function EntityChip() {
  const { entities, current, setCurrentId } = useEntities();
  const active = entities.filter((e) => e.status === "ativa");
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!open) return;
    const h = (e: MouseEvent) => { if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false); };
    const k = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("mousedown", h); document.addEventListener("keydown", k);
    return () => { document.removeEventListener("mousedown", h); document.removeEventListener("keydown", k); };
  }, [open]);
  if (!current) return <span className="chip" title="Entidade">—</span>;
  if (active.length < 2) return <span className="chip" title="Entidade" data-entity-chip>{current.name}</span>;
  return (
    <div className="menu-wrap" ref={ref}>
      <button className="chip btnlike" onClick={() => setOpen(!open)} aria-expanded={open} aria-haspopup="menu" title="Trocar de empresa" data-entity-chip>
        {current.name}<ChevronDown size={14} />
      </button>
      {open && (
        <div className="menu" role="menu" aria-label="Empresas">
          <div className="mh">Empresa</div>
          {active.map((e) => (
            <button key={e.id} role="menuitemradio" aria-checked={e.id === current.id} className={e.id === current.id ? "sel" : ""} onClick={() => { setCurrentId(e.id); setOpen(false); }}>
              {e.id === current.id ? "✓ " : " "}{e.name}
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
